export default "__VITE_ASSET__COaMKQHF__"